import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AnimateHeight from "react-animate-height";
import { X, AlertCircle } from "react-feather";
import { State } from "../../../store/state";
import { clearApiError } from "../../../store/donation/actions";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../store/donation/types";
import { NotificationWrapper, NotificationContent, NotificationIcon, NotificationMessage, NotificationCloseButton } from "./ApiErrorNotification.style";
export const ApiErrorNotification: React.FC<{
  genericErrorMessage?: string;
}> = t0 => {
  const $ = _c(22);
  const {
    genericErrorMessage: t1
  } = t0;
  const genericErrorMessage = t1 === undefined ? "Something went wrong, please try again later." : t1;
  const dispatch = useDispatch();
  const apiError = useSelector(_temp);
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState(null);
  let t2;
  let t3;
  if ($[0] !== apiError) {
    t2 = () => {
      if (typeof apiError !== "undefined") {
        setMessage(apiError);
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    t3 = [apiError];
    $[0] = apiError;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== dispatch) {
    t4 = () => {
      setIsVisible(false);
      setTimeout(() => {
        dispatch(clearApiError());
      }, 250);
    };
    $[3] = dispatch;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClose = t4;
  let t5;
  if ($[5] !== handleClose || $[6] !== isVisible) {
    t5 = () => {
      if (isVisible) {
        const timer = setTimeout(() => {
          handleClose();
        }, 8000);
        return () => clearTimeout(timer);
      }
    };
    $[5] = handleClose;
    $[6] = isVisible;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isVisible) {
    t6 = [isVisible];
    $[8] = isVisible;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t5, t6);
  const t7 = isVisible ? "auto" : 0;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <NotificationIcon><AlertCircle size={24} /></NotificationIcon>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = message || genericErrorMessage;
  let t10;
  if ($[11] !== t9) {
    t10 = <NotificationMessage>{t9}</NotificationMessage>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <X size={24} />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== handleClose) {
    t12 = <NotificationCloseButton onClick={handleClose} aria-label="Close notification">{t11}</NotificationCloseButton>;
    $[14] = handleClose;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12) {
    t13 = <NotificationWrapper data-cy="api-error-notification"><NotificationContent>{t8}{t10}{t12}</NotificationContent></NotificationWrapper>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t7) {
    t14 = <AnimateHeight height={t7} duration={300} animateOpacity={true}>{t13}</AnimateHeight>;
    $[19] = t13;
    $[20] = t7;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};
function _temp(state) {
  return state.donation.apiError;
}